import { render } from "./vagentlistadd.vue?vue&type=template&id=21d8b75a&scoped=true"
import script from "./vagentlistadd.vue?vue&type=script&lang=js"
export * from "./vagentlistadd.vue?vue&type=script&lang=js"

import "./vagentlistadd.vue?vue&type=style&index=0&id=21d8b75a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d8b75a"]])

export default __exports__